module.exports = __webpack_public_path__ + "img/info_black_24dp 1.63c81b3f.svg";